export default class DtoPrevention {
    constructor(obj) {
        this.idStation = obj.idStation
        this.code = obj.code
    }
}